/**
 * User Role Management Page
 * Admin panel for managing user roles and permissions
 * Requires owner (*) permission
 */

import React, { useState } from "react";
import Container from "../../componentLibrary/Container";
import Button from "../../componentLibrary/Button";
import AuditLogView from "./components/AuditLogView";
import UserRoleManagementView from "./components/UserRoleManagementView";

type ViewMode = "management" | "auditLog";

const UserRoleManagementPage = () => {
  // View mode state
  const [viewMode, setViewMode] = useState<ViewMode>("management");

  return (
    <div className="p-2 sm:p-4 pb-32">
      <Container>
        <div className="flex justify-between items-center mb-4 lg:flex-row flex-col gap-4">
          <h1 className="text-2xl font-bold">User Role Management</h1>

          <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
            <Button
              onClick={() => setViewMode("management")}
              variant={viewMode === "management" ? "primary" : "alternative"}
              className={`${
                viewMode === "management"
                  ? "bg-white text-electrum shadow-sm"
                  : "text-gray-600 hover:text-gray-900 px-3"
              }`}
            >
              User Role Management
            </Button>
            <Button
              onClick={() => setViewMode("auditLog")}
              variant={viewMode === "auditLog" ? "primary" : "alternative"}
              className={`${
                viewMode === "auditLog"
                  ? "bg-white text-electrum shadow-sm"
                  : "text-gray-600 hover:text-gray-900 px-3"
              }`}
            >
              Audit Log
            </Button>
          </div>
        </div>

        {viewMode === "management" ? (
          <UserRoleManagementView />
        ) : (
          <AuditLogView />
        )}
      </Container>
    </div>
  );
};

export default UserRoleManagementPage;
